function get_closest_array_value(counts, goal) {
    return counts.reduce((prev, curr) => Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
}

$.fn.serializeAll = function () {
    var data = $(this).serializeArray();
    $(':disabled[name]', this).each(function () {
        data.push({name: this.name, value: $(this).val()});
    });
    
    // Handle use_extensions checkbox explicitly (unchecked checkboxes don't get serialized)
    var use_extensions_checked = $('#use_extension_checkbox').is(':checked');
    data.push({name: 'use_extensions', value: use_extensions_checked ? 'on' : 'off'});
    
    // Filter out extender_type values when extensions are disabled
    data = data.filter(function(item) {
        if (item.name === 'extender_type') {
            // Remove extender_type if extensions are disabled or if value is empty/none
            if (!use_extensions_checked || item.value === '' || item.value === 'none') {
                return false;
            }
        }
        return true;
    });
    
    return data;
};

/**
 * Ensure mounting-part fields and ranked combo data match the live selection.
 *
 * Mirrors ensure_extender_cookie_fields: share/cookie payloads must store the
 * parts currently active on cf, not only what serialize/ranking produced.
 *
 * @param {Array} data Serialized configurator cookie payload.
 * @returns {Array}
 */
function ensure_mounting_parts_cookie_fields(data) {
    var mp_cyl = '';
    var mp_rod = '';
    var mp_cyl_type = '';
    var mp_rod_type = '';
    var gasspring = '';
    var extender_type = 'none';
    var i;
    var ranked;
    var active_combo;

    if (!data || !Array.isArray(data)) {
        return data;
    }

    if (typeof cf !== 'undefined' && cf.sync_mounting_parts_to_form) {
        cf.sync_mounting_parts_to_form();
    }

    if (typeof cf !== 'undefined') {
        if (cf.mp_cyl && cf.mp_cyl.hahntype) {
            mp_cyl = cf.mp_cyl.hahntype;
        }
        if (cf.mp_rod && cf.mp_rod.hahntype) {
            mp_rod = cf.mp_rod.hahntype;
        }
        if (cf.gs && cf.gs.description) {
            gasspring = cf.gs.description;
        }
    }

    if (!mp_cyl) {
        mp_cyl = $('#mp_cyl').val() || '';
    }
    if (!mp_rod) {
        mp_rod = $('#mp_rod').val() || '';
    }
    if (!gasspring) {
        gasspring = $('#gasspring').val() || '';
    }

    mp_cyl_type = $("input[name='mp_cyl_type']:checked").val() || '';
    mp_rod_type = $("input[name='mp_rod_type']:checked").val() || '';

    if (!mp_cyl || !mp_rod) {
        return data;
    }

    data = data.filter(function (item) {
        return item.name !== 'mp_cyl' &&
            item.name !== 'mp_rod' &&
            item.name !== 'mp_cyl_type' &&
            item.name !== 'mp_rod_type' &&
            item.name !== 'gasspring';
    });

    if (gasspring) {
        data.push({ name: 'gasspring', value: gasspring });
    }
    data.push({ name: 'mp_cyl', value: mp_cyl });
    data.push({ name: 'mp_rod', value: mp_rod });

    if (mp_cyl_type) {
        data.push({ name: 'mp_cyl_type', value: mp_cyl_type });
    }
    if (mp_rod_type) {
        data.push({ name: 'mp_rod_type', value: mp_rod_type });
    }

    if ($('#use_extension_checkbox').is(':checked')) {
        extender_type = $('#extender_type').val() || 'none';
        if ((!extender_type || extender_type === 'none') &&
            typeof cf !== 'undefined' && cf.ex && cf.ex.filename) {
            extender_type = cf.ex.filename;
        }
    }

    if (!extender_type || extender_type === '') {
        extender_type = 'none';
    }

    active_combo = {
        gs: gasspring,
        mp_cyl: mp_cyl,
        mp_rod: mp_rod,
        ex: extender_type,
        has_extender: extender_type !== 'none'
    };

    for (i = 0; i < data.length; i++) {
        if (data[i].name !== 'gs_ranked') {
            continue;
        }

        try {
            ranked = JSON.parse(data[i].value);

            if (!Array.isArray(ranked)) {
                ranked = [];
            }

            ranked = ranked.filter(function (combo) {
                return !(combo.gs === active_combo.gs &&
                    combo.mp_cyl === active_combo.mp_cyl &&
                    combo.mp_rod === active_combo.mp_rod &&
                    (combo.ex || 'none') === active_combo.ex);
            });

            // Drop the previous "best" combo for this gas spring so restore
            // cannot pick ranked MPs over the user's active selection.
            ranked = ranked.filter(function (combo) {
                return combo.gs !== active_combo.gs;
            });

            ranked.unshift(active_combo);
            data[i].value = JSON.stringify(ranked.slice(0, 5));
        } catch (e) {
        }
    }

    return data;
}

/**
 * Ensure extender fields and ranked combo data include the active extension.
 *
 * @param {Array} data Serialized configurator cookie payload.
 * @returns {Array}
 */
function ensure_extender_cookie_fields(data) {
    var extender_type = '';
    var use_extensions = $('#use_extension_checkbox').is(':checked') ? 'on' : 'off';
    var i;

    if (typeof cf !== 'undefined' && cf.sync_extender_to_form) {
        cf.sync_extender_to_form();
    }

    extender_type = $('#extender_type').val() || '';

    if ((!extender_type || extender_type === 'none') && typeof cf !== 'undefined' && cf.ex && cf.ex.filename) {
        extender_type = cf.ex.filename;
        use_extensions = 'on';
    }

    if (!extender_type || extender_type === 'none') {
        return data;
    }

    data = data.filter(function (item) {
        return item.name !== 'extender_type' && item.name !== 'use_extensions';
    });

    data.push({ name: 'extender_type', value: extender_type });
    data.push({ name: 'use_extensions', value: use_extensions });

    for (i = 0; i < data.length; i++) {
        if (data[i].name !== 'gs_ranked') {
            continue;
        }

        try {
            var ranked = JSON.parse(data[i].value);
            var stored_gasspring = '';
            var stored_mp_cyl = '';
            var stored_mp_rod = '';
            var combo_index;

            if (!Array.isArray(ranked)) {
                continue;
            }

            for (combo_index = 0; combo_index < data.length; combo_index++) {
                if (data[combo_index].name === 'gasspring') {
                    stored_gasspring = data[combo_index].value;
                } else if (data[combo_index].name === 'mp_cyl') {
                    stored_mp_cyl = data[combo_index].value;
                } else if (data[combo_index].name === 'mp_rod') {
                    stored_mp_rod = data[combo_index].value;
                }
            }

            for (combo_index = 0; combo_index < ranked.length; combo_index++) {
                if (ranked[combo_index].gs === stored_gasspring &&
                    ranked[combo_index].mp_cyl === stored_mp_cyl &&
                    ranked[combo_index].mp_rod === stored_mp_rod) {
                    ranked[combo_index].ex = extender_type;
                    ranked[combo_index].has_extender = true;
                    break;
                }
            }

            if (combo_index === ranked.length && stored_gasspring) {
                ranked.unshift({
                    gs: stored_gasspring,
                    mp_cyl: stored_mp_cyl,
                    mp_rod: stored_mp_rod,
                    ex: extender_type,
                    has_extender: true
                });
            }

            data[i].value = JSON.stringify(ranked);
        } catch (e) {
        }
    }

    return data;
}

function newton_to_lbs(newton){
    return (newton * 0.224808943).toFixed(1);
}

function lbs_to_newton(lbs){
    return Math.round(lbs / 0.224808943);
}

function inch_to_mm(inch) {
    return Math.round(inch * 25.4);
}

function mm_to_inch(mm) {
    return (Math.round(mm / 25.4 * 100) / 100).toFixed(2);
}

function flbtoa(input) {
    input = encodeURI(input);
    return btoa(input);
}

function flatob(input) {
    var output = decodeURI(atob(input));

    return output;
}

var startTime, endTime;

function start() {
    startTime = new Date();
}

function end() {
    endTime = new Date();
    var timeDiff = endTime - startTime;
    timeDiff /= 1000;
    var seconds = timeDiff;
    
}

function get_random_hex_color() {
    let colors = '0123456789ABCDEF';
    let color = '#';

    for (let i = 0; i < 6; i++) {
        color += colors[Math.floor(Math.random() * 16)];
    }

    return color;
}

function find_child_by_name(parent, name) {
    let found = null;
    parent.traverse((child) => {
        if (child.name === name) {
            found = child;
        }
    });
    return found;
}